var map = {
	"./de/warrior-name.png": "56BC",
	"./en/warrior-name.png": "lLrT",
	"./es/warrior-name.png": "l/Xq",
	"./fr/warrior-name.png": "z3oj",
	"./ja/warrior-name.png": "hMvo",
	"./ko/warrior-name.png": "lUsL",
	"./pt/warrior-name.png": "Sxrj",
	"./ru/warrior-name.png": "PbF0",
	"./th/warrior-name.png": "IKux",
	"./zh-Hant/warrior-name.png": "Ln3I"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KpGO";